export const ROOT = '/TrainingMasterAPI';
export const CATEGORYROOT = '/TrainingCategoryAPI';
export const LIST = `${ROOT}/gettrainingpage`;
export const EXPORT = `${ROOT}/export`;
export const TRAINING_CATEGORY = `${CATEGORYROOT}/gettrainingcategoryddl`;